const STORAGE_KEY = "psy_recommendation_id";

export function savePsyRecommendationId(id: string): void {
  sessionStorage.setItem(STORAGE_KEY, id);
}

export function getPsyRecommendationId(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearPsyRecommendationId(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
